const RolesPermissionIcon = (color:any) => {
  return (
      <svg
        className="ml-7 mr-7"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.625 1.06445C8.72775 1.06445 6.375 3.41645 6.375 6.31445C6.375 9.2117 8.72775 11.5645 11.625 11.5645C14.5222 11.5645 16.875 9.2117 16.875 6.31445C16.875 3.41645 14.5222 1.06445 11.625 1.06445ZM11.625 2.56445C13.695 2.56445 15.375 4.24445 15.375 6.31445C15.375 8.3837 13.695 10.0645 11.625 10.0645C9.555 10.0645 7.875 8.3837 7.875 6.31445C7.875 4.24445 9.555 2.56445 11.625 2.56445Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.625 20.5645H12C12.414 20.5645 12.75 20.9005 12.75 21.3145C12.75 21.7285 12.414 22.0645 12 22.0645H1.875C1.461 22.0645 1.125 21.7285 1.125 21.3145C1.125 21.3145 1.125 20.6957 1.125 19.8145C1.125 16.0862 4.14675 13.0645 7.875 13.0645H12C12.414 13.0645 12.75 13.4005 12.75 13.8145C12.75 14.2285 12.414 14.5645 12 14.5645H7.875C4.9755 14.5645 2.625 16.915 2.625 19.8145V20.5645Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.996 17.5645C21.996 17.1497 21.6608 16.8145 21.246 16.8145H14.5605C14.1465 16.8145 13.8105 17.1497 13.8105 17.5645V21.3145C13.8105 21.7285 14.1465 22.0645 14.5605 22.0645H21.246C21.6608 22.0645 21.996 21.7285 21.996 21.3145V17.5645ZM15.3105 18.3145V20.5645H20.496V18.3145H15.3105Z"
          fill={color?.color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9034 13.0645C18.6616 13.0645 19.3891 13.3652 19.9254 13.9015C20.4616 14.4377 20.7631 15.1652 20.7631 15.9235V17.5645C20.7631 17.9785 20.4271 18.3145 20.0131 18.3145H15.7944C15.3796 18.3145 15.0444 17.9785 15.0444 17.5645V15.9235C15.0444 14.3447 16.3246 13.0645 17.9034 13.0645ZM19.2631 16.8145V15.9235C19.2631 15.5627 19.1199 15.217 18.8649 14.9627C18.6099 14.7077 18.2641 14.5645 17.9034 14.5645C17.1526 14.5645 16.5444 15.1727 16.5444 15.9235V16.8145H19.2631Z"
          fill={color?.color}
        />
      </svg>
  );
};
export default RolesPermissionIcon;
